import React, { useEffect, useRef } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getDomDistance, getQuery } from '@src/utils/index';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const Banner = () => {
    const imgRef = useRef();
    const bannerImgUrl = 'https://x0.ifengimg.com/feprod/c/2025_7_21/13_12_29/banner_01.jpg';
    const infoImgUrl = 'https://x0.ifengimg.com/feprod/c/2024_9_10/15_11_19/8066E471430A5389558CB8642B2EA53A8BE9273F_size52_w1005_h492.png';

    useEffect(() => {
        const bannerImgObj = new Image();

        bannerImgObj.onload = () => {
            const fromWecom = getQuery(location.href, 'from_wecom');
            const domPageTop = getDomDistance(imgRef.current).top;

            if (domPageTop && fromWecom === '1') {
                window.scroll({ top: domPageTop, behavior: 'smooth' });
            }
        };

        bannerImgObj.src = bannerImgUrl;
    }, []);

    return (
        <div className={styles.banner}>
            <img
                src={bannerImgUrl}
                className={styles.banner1}
            />
        </div>
    );
};

export default errorBoundary(Banner);
